import React, { useState, useEffect } from "react";
import { TEXT } from "Clients/ACCB/ACCBTheme";
import {
  Button,
  Typography,
  makeStyles,
  Tooltip
} from "@material-ui/core";
import { useSnackbar } from "contexts/SnackbarContext";
import { generateDocIndexFile } from "./FileApi";

const useStyles = makeStyles((theme) => ({
  indexBtn: {
    background: "white",
    border: "1px solid #E0E0E0",
    boxShadow: "none",
    width: "10.5rem",
    textTransform: "none",
    [theme.breakpoints.down("sm")]: {
      width: "8.375rem",
    },
    [theme.breakpoints.down("xs")]: {
      width: "7.125rem",
    },
    // "&:disabled": {
    //   background: "#F5F5F5",
    //   color: TEXT.muted,
    //   borderColor: "#E0E0E0",
    // }
  },
  indexBtnText: {
    fontSize: "0.9375rem",
    fontWeight: "500",
    textTransform: "none",
    [theme.breakpoints.down("xs")]: {
      fontSize: "0.875rem",
    },
  },
  disabledText: {
    color: TEXT.muted,
  }
}));

export default function BundleIndex({ workspaceId, firstLevelFolderId, reload, paginationStatus, setPaginationStatus }) {
  const classes = useStyles();
  const { showSnackbar } = useSnackbar();

  const [isProcessing, setIsProcessing] = useState(false);

  const handleGenerateIndex = async () => {
    if (paginationStatus !== 2 || isProcessing) return;

    setIsProcessing(true);
    showSnackbar("Generating document index bundle. Please wait...", "info");

    try {
      const res = await generateDocIndexFile(workspaceId, firstLevelFolderId);
      if (res?.data?.success) {
        showSnackbar(res.data.success, "success");
        if (reload) reload();
      }
    } catch (error) {
      console.error("Index generation failed:", error);
      showSnackbar(
        error?.response?.data?.error || "Failed to generate index file.",
        "error"
      );
    } finally {
      setIsProcessing(false);
    }
  };

  const getTooltipText = () => {
    if (paginationStatus === 2) {
      return "Generate complete bundle index.";
    } else if (paginationStatus === 1) {
      return "Pagination is currently in progress. Indexing will be enabled once pagination completes.";
    } else {
      return "Please paginate all files in the workspace before generating the index.";
    }
  };

  const isBtnDisabled = paginationStatus !== 2 || isProcessing;

  return (
    <Tooltip title={getTooltipText()} placement="top" arrow>
      <span>
        <Button
          color="primary"
          onClick={handleGenerateIndex}
          className={classes.indexBtn}
          disabled={isBtnDisabled}
        >
          <Typography
            className={`${classes.indexBtnText} ${isBtnDisabled ? classes.disabledText : ""}`}
          >
            {isProcessing ? "Processing..." : "Index"}
          </Typography>
        </Button>
      </span>
    </Tooltip>
  );
}
